<template>
  <div
    v-if="!loadingPage"
  >
    <UploadFolderDetails
      :key="responseId"
      :discussion-messages="discussionMessages"
      :response="response"
      :response-assignees="responseAssignees"
      :response-id="responseId"
    />
  </div>
</template>

<script lang="ts" setup>
import UploadFolderDetails from '@/VueComponents/PageComponents/UploadFolderDetails/UploadFolderDetails.vue';
import SelfResponseService from '@/Services/selfResponseService';
import discussionService from '@/Services/discussionService';
import { ref } from 'vue';
import businessService from '@/Services/businessService';
import usePageLoading from '@/VueCore/utils/usePageLoading';

const response = ref(null);
const discussionMessages = ref([]);
const responseAssignees = ref(null);
// Used as :key value of the component what allows to recreate it when id is changed
const responseId = ref('');

businessService.getRequestAssigneeSummaries().then(data => responseAssignees.value = data);

const { loadingPage } = usePageLoading(async params => {
  responseId.value = params.id as string;
  response.value = await SelfResponseService.getResponse(params.id as string);
  discussionMessages.value = (await discussionService.getMessagesByResponseId(params.id as string)) ?? [];
}, error => console.error('Failed to fetch upload folder details:', error));
</script>
